module.exports = __webpack_public_path__ + "media/images/flags/gr-8e24146131f2b7fdde835aecbfba02db.svg";